export enum SnackbarType {
  Error = 'error',
  Success = 'success',
}
